module.exports = __webpack_public_path__ + "img/star-half.1f0599b2.svg";